import { SectionPage } from 'components/section/SectionPage';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouterProps } from 'react-router';
import { Menu } from 'semantic-ui-react';
import styled from 'styled-components';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const SectionMenuSc = styled(Menu)`
  &.ui.secondary.menu {
    flex-wrap: wrap;
  }
`;

interface Props extends RouterProps, MessageSourceProps {
  sectionPages: SectionPage[]
}

interface State {
  activeMenuItem: string
}

class SectionMenu extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {history} = this.props;

    let activeMenuItem = history.location.pathname;
    this.state = {
      activeMenuItem: this.getActiveMenuItem(activeMenuItem)
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {

    const {activeMenuItem} = this.state;
    const path = this.props.history.location.pathname;

    if (path !== activeMenuItem) {
      this.setActiveMenuItem(path);
    }
  };

  onMenuItemClick = (route: string) => {
    const {history} = this.props;

    this.setActiveMenuItem(route);
    history.push(route);
  };

  setActiveMenuItem = (activeMenuItem: string) => {
    const foundActiveMenuItem = this.getActiveMenuItem(activeMenuItem);

    if (activeMenuItem !== foundActiveMenuItem) {
      this.props.history.push(foundActiveMenuItem);
    } else {
      this.setState({
        activeMenuItem: foundActiveMenuItem
      });
    }
  };

  render(): React.ReactNode {
    return (
        <SectionMenuSc pointing secondary>
          {this.renderMenuItems()}
        </SectionMenuSc>
    );
  }

  getActiveMenuItem = (activeMenuItem: string) => {
    const {sectionPages} = this.props;
    return sectionPages.map(x => x.uri).includes(activeMenuItem)
        ? activeMenuItem
        : sectionPages[0].uri
  };

  renderMenuItems = () => {
    const {getMessage, sectionPages} = this.props;
    let menuItems = [];
    for (let page of sectionPages) {
      if (page.disabled === true) {
        continue;
      }
      const onPageClick = () => this.onMenuItemClick(page.uri);
      menuItems.push(
          <Menu.Item
              content={(<span>{`${getMessage(`header.navigation.${page.id}`)}`}</span>)}
              active={this.state.activeMenuItem === page.uri}
              onClick={onPageClick}
              key={`${page.id} menu`}
          />
      );
    }
    return menuItems;
  };

}

export default withRouterWorkaround(withMessages(SectionMenu));
